import { ProfileProvider } from '@/providers/profile/profile.provider';
import { COMPARISON_ACCESS } from '@/providers/rights.constants';
import { inject, Injectable } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import type { Observable } from 'rxjs';
import type { BuildingsIndicatorsAnalysisTab } from './buildings-indicators-analysis.interface';

@Injectable({
    providedIn: 'root'
})
export class BuildingsIndicatorsAnalysisFeatureService {
    private _router = inject(Router);
    private _profileProvider = inject(ProfileProvider);

    goToFeature(tab: BuildingsIndicatorsAnalysisTab = 'comparison') {
        this._router.navigate(['/', 'indicators-buildings-comparison', tab]);
    }

    hasFeatureAccess$(): Observable<boolean> {
        return this._profileProvider.hasRight$(COMPARISON_ACCESS);
    }

    hasFeatureAccess(): Promise<boolean> {
        return this._profileProvider.hasRight(COMPARISON_ACCESS);
    }
}

export const buildingsIndicatorsAnalysisGuard: CanActivateFn & CanActivateChildFn = () =>
    inject(BuildingsIndicatorsAnalysisFeatureService).hasFeatureAccess();
